import type { ConsumerCheckoutCartsResponse } from './checkout.types';
import { useShowConsumerCheckout } from './get';

const getRequiredFields = (data?: ConsumerCheckoutCartsResponse) => {
  return data?.checkout.carts.reduce(
    (acc, cart) => {
      Object.entries(cart.required_fields).forEach(([key, value]) => {
        if (value) {
          acc[key] = true;
        }
      });
      return acc;
    },
    {
      first_name: false,
      last_name: false,
      email: false,
      phone_number: false,
    }
  );
};

const useShowConsumerCheckoutRequiredFields = ({ checkoutId }: { checkoutId: string }) => {
  return useShowConsumerCheckout({
    checkoutId,
    select: getRequiredFields,
  });
};

export { useShowConsumerCheckoutRequiredFields };
